module.exports = __webpack_public_path__ + "static/media/success-icon.d64529f6.svg";